import React from "react";

import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";

import DashboardService from "../../../core/services/dashboardService.js";


const GRID_DIMENSION_WIDTH = 30;
const GRID_DIMENSION_HEIGHT = 30;

export default class ResizeGrid extends BaseComponent {
  constructor(props) {
    super(props);
    this.gridster = null;
  }

  componentWillUnmount() {
    this.gridster.destroy();
    this.gridster = null;
    this.unsubscribeAll();
  }

  calcGridMinWidth() {
    let maxWidth = 0;
    this.props.dashboardState.dashboardState.map(state => {
      let gridsterModel = state.gridsterModel;
      if (gridsterModel) {
        let width = (gridsterModel.col + gridsterModel.size_x) * GRID_DIMENSION_WIDTH;
        if (width > maxWidth) {
          maxWidth = width;
        }
      }
    });
    return maxWidth;
  }

  getWidgetSize() {
    let x = 0, y = 0;
    this.props.dashboardState.dashboardState.forEach(state => {
      const gridsterModel = state.gridsterModel;
      if (gridsterModel) {
        const sizeX = gridsterModel.col + gridsterModel.size_x - 1;
        const sizeY = gridsterModel.row + gridsterModel.size_y - 1;
        if (sizeX > x) {
          x = sizeX;
        }
        if (sizeY > y) {
          y = sizeY;
        }
      }
    });

    return {x, y};
  }

  componentDidMount() {
    const minWidth = this.calcGridMinWidth();
    let wrapperWidth = $("#gridster-wrapper").width() - 120;
    if (minWidth > wrapperWidth) {
      $(".resizeGrid").css("min-width", minWidth);
    }

    let baseDimensions = [GRID_DIMENSION_WIDTH, GRID_DIMENSION_HEIGHT];

    const dashboardVariables = DashboardService.getCurrentDashboardVariables();
    if (dashboardVariables.gridBaseDimensions) {
      baseDimensions = [dashboardVariables.gridBaseDimensions.value.width, dashboardVariables.gridBaseDimensions.value.height];
    }

    this.gridster = $(".resizeGrid > ul").gridster(
      {
        namespace: '#resizeGrid',
        widget_margins: [0, 0],
        widget_base_dimensions: baseDimensions,
        min_rows: 50,
        resize: {
          enabled: true,
          start: (e, ui, $widget) => {
            $widget.css("background", "rgba(0,255,0,0.3)");
          },
          resize: (e, ui, $widget) => {
          },
          stop: (e, ui, $widget) => {
            $widget.css("background", "transparent");
            let width = parseInt($widget.attr('data-sizex')) * baseDimensions[0];
            let height = parseInt($widget.attr('data-sizey')) * baseDimensions[1];

            this.publish(InternalEvent.Dashboard.RESIZE_ALL_WIDGETS, {width, height});
          }
        },
      }).data('gridster').disable();

    this.subscribe(InternalEvent.Dashboard.DASHBOARD_LOCK_TOGGLED, () => {
      $("#resizeGrid").toggle();
    });
  }

  render() {
    const size = this.getWidgetSize();
    const isDashboardLocked = DashboardService.getActiveDashboardLockState();
    return (
      <div id="resizeGrid" className="resizeGrid gridster"
           style={{position: 'absolute', top: 15, left: 15, right: 0}}>
        <ul>
          <li className="widget noselect" data-row="1" data-col="1" data-sizex={size.x} data-sizey={size.y}
              style={{borderBottom: 'none', zIndex: 1}}></li>
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/grid/resizeGrid.jsx